import { render, staticRenderFns } from "./two-step.vue?vue&type=template&id=25b3d350&scoped=true"
import script from "./two-step.vue?vue&type=script&lang=js"
export * from "./two-step.vue?vue&type=script&lang=js"
import style0 from "./two-step.vue?vue&type=style&index=0&id=25b3d350&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b3d350",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25b3d350')) {
      api.createRecord('25b3d350', component.options)
    } else {
      api.reload('25b3d350', component.options)
    }
    module.hot.accept("./two-step.vue?vue&type=template&id=25b3d350&scoped=true", function () {
      api.rerender('25b3d350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/complaintreporting/offline/components/two-step.vue"
export default component.exports